module.exports = __webpack_public_path__ + "static/chat-534ec0d62426645a1934cbd618173a42.png";